// "Upload live from your camera" (/live-uploading, src/pages/LiveUploading.tsx) is STAGING ONLY until the owner
// launches it: where it's off, /live-uploading is a real 404, the sitemap leaves it out and the footers don't link to it.
//
// Same switch as the guides (src/lib/guidesFlag.ts): the deployment's pinned PHOTOHAWK_ENV, never a visitor's
// override. Launch: set LIVE_UPLOADING_IN_PROD to true and add a ":::link /live-uploading" to the help article
// upload-live-with-cloudtether (its link check needs a public page) in a reviewed PR, deploy prod, then import the
// article into the prod help store (help-seed-import, slugs=upload-live-with-cloudtether).

import { deploymentEnv, type DeploymentEnv } from "./homeFlag";

export const LIVE_UPLOADING_IN_PROD = true;

/** Whether the page is on for a deployment env. */
export const liveUploadingEnabledFor = (env: DeploymentEnv, inProd: boolean = LIVE_UPLOADING_IN_PROD): boolean =>
  env !== "prod" || inProd;

/** Whether this deployment shows the page (staging: yes; prod: once the screenshots are in). */
export const isLiveUploadingEnabled = (host?: string): boolean => liveUploadingEnabledFor(deploymentEnv(host));
